import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useSeoMeta } from "@/lib/useSeoMeta";
import { ArrowLeft, Search } from "lucide-react";

/*
 * Page 404 — Soft-404-friendly.
 * Ne peut pas renvoyer un vrai HTTP 404 sans SSR, mais on ajoute :
 *   <meta name="robots" content="noindex, nofollow">
 * Googlebot voit ce meta après hydratation JS et n'indexe pas l'URL.
 */
export default function NotFound() {
  useSeoMeta({
    title: "Page introuvable — EmpCo",
    description: "La page que vous cherchez n'existe pas ou a été déplacée.",
    robots: "noindex, nofollow",
  });
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header variant="public" />
      <main className="flex-1 flex items-center justify-center px-6 py-16" data-testid="not-found-page">
        <div className="max-w-md text-center">
          <p className="eyebrow mb-3">Erreur 404</p>
          <h1 className="text-5xl sm:text-6xl font-serif text-primary mb-4">Page introuvable</h1>
          <p className="text-muted-foreground leading-relaxed mb-8">
            L'URL demandée n'existe pas sur EmpCo, ou a été déplacée. Retournez à l'accueil ou explorez nos guides sur la conformité UE 2024/825.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="inline-flex items-center justify-center gap-2 bg-primary text-white px-5 py-3 rounded-full text-sm font-semibold hover:bg-[hsl(var(--primary-light))]" data-testid="notfound-home">
              <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
            </Link>
            <Link to="/guides" className="inline-flex items-center justify-center gap-2 bg-white border border-border text-slate-700 px-5 py-3 rounded-full text-sm font-semibold hover:border-primary hover:text-primary" data-testid="notfound-guides">
              <Search className="w-4 h-4" /> Voir nos guides
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
